import React, { useState, useEffect, useContext } from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import PageLayout from "../layout/page-layout"
import { database } from "../../firebase"

import CueStyles from "./cue.module.scss"

/*
  TODO: Reformat barber checkboxes and add custom styles

*/

const Cue = () => {
  const [pickedBarber, setPickedBarber] = useState("")
  const [barbers, setBarbers] = useState([])

  const noBarber = pickedBarber === ""

  const fetchBarbers = () => {
    database
      .collection("barbers")
      .get()
      .then(snapshot => {
        const barberData = snapshot.docs.map(doc => {
          return {
            id: doc.id,
            ...doc.data(),
          }
        })

        setBarbers(barberData)
      })
  }

  useEffect(() => {
    fetchBarbers()
  }, [])

  const barberList = barbers.map(barber => (
    <label key={barber.id} className="input-container">
      {barber.id}
      <input
        id={barber.id}
        type="radio"
        name="barber"
        value={barber.id}
        onChange={() => setPickedBarber(barber.id)}
      />
      <span className="checkmark"></span>
    </label>
  ))

  return (
    <PageLayout title="Book a barber">
      {barberList}
      <div className={CueStyles.buttons}>
        <Link to={`/walk-in?barber=${pickedBarber}`}>
          <button disabled={noBarber}>Walk in</button>
        </Link>
        <Link to={`/book?barber=${pickedBarber}`}>
          <button disabled={noBarber}>Book</button>
        </Link>
      </div>
    </PageLayout>
  )
}

export default Cue
